module.exports = __webpack_public_path__ + "images/help/icn-videoplay@2x-ce22b547183da6eebeb4cbced094d8f5.png";